import { LoginPopup } from '@/components';
import { useResponsive } from '@/hooks';
import { ResponsiveCollection } from '@/interfaces';
import type { IPmtOnboardingPopup } from '@/modules/pmt/interfaces';
import type { FC } from 'react';
import { useMemo, useState } from 'react';
import LoginBanner from '../LoginBanner';
import { LoginBannerWrapper } from './Account.styles';
import { AccountView } from './AccountView';
import DataPrivacy from './DataAndPrivacy';

enum AccountViewState {
  ACCOUNT = 'account',
  DATA_PRIVACY = 'data_privacy',
}

interface AccountProps {
  pmtOnboardingPopUp: IPmtOnboardingPopup;
  pmtEmailSyncOnboardingPopUp: IPmtOnboardingPopup;
}

const Account: FC<AccountProps> = (props) => {
  const { isDesktopPMT } = useResponsive([ResponsiveCollection.DesktopPMT]);
  const [viewState, setViewState] = useState<AccountViewState>(AccountViewState.ACCOUNT);

  const handleNavigateToDataPrivacy = () => {
    setViewState(AccountViewState.DATA_PRIVACY);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleNavigateBack = () => {
    setViewState(AccountViewState.ACCOUNT);
  };

  const accountPageView = useMemo(() => {
    return {
      [AccountViewState.ACCOUNT]: <AccountView onNavigateToDataPrivacy={handleNavigateToDataPrivacy} />,
      [AccountViewState.DATA_PRIVACY]: <DataPrivacy onBackClick={handleNavigateBack} />,
    };
  }, [handleNavigateBack, handleNavigateToDataPrivacy]);

  return (
    <>
      {/* Login banner - Only show at this position on mobile */}
      <LoginBannerWrapper showOn='mobile'>
        <LoginBanner isDesktopPMT={isDesktopPMT} />
      </LoginBannerWrapper>

      {/* Render page view based on view state */}
      {accountPageView[viewState]}

      <LoginPopup {...props} />
    </>
  );
};

export default Account;
